<template>
    <modal dialog="modal-lg" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="true">
        <div slot="body" class="p-4">

            <h2 class="text-center mb-3">Events where this promocode can be used</h2>

            <div>
                <div v-if="isLoading" class="w-100 text-center">
                    <loader />
                </div>

                <div v-else class="eventList">

                    <div class="w-10." v-for="eventsDay in eventsList" v-if="hideDaysWithoutEvents == false || eventsDay.events.length > 0">
                        <div class="w-100 bg-light dark bold px-1">{{getDateToDisplay(eventsDay)}}</div>

                        <div v-if="eventsDay.events.length == 0">
                            <div class="w-100 bg-lighter dark text-center"> -- no events --</div>
                        </div>
                        <div v-else>
                            <div class="w-100 bg-lighter d-flex px-2" v-for="event in eventsDay.events" :key="event.id">
                                <div class="flex-grow-1">{{getEventName(event)}}</div>
                                <div>{{getEventStartHour(event)}}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div slot="footer" class="d-flex w-100 justify-content-between align-items-center">

            <div>
                <checkbox v-model="hideDaysWithoutEvents">
                    Hide days without events
                </checkbox>
            </div>

            <button type="button" class="btn ok wider" @click="pressOk">Ok</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Loader from '@/tools/loaders/loader1'
    import Modal from './Modal'

    export default {
        created: function () {
            this.getEventsList()
        },
        data: function() {
            return {
                hideDaysWithoutEvents: false,
                isLoading: false,
                currentDayIndex: 0,
                eventsList: [],
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedPromocode',
            ]),
            numberOfDays: function () {
                return this.eventsList.length
            },
            selectedDay: function () {
                return this.eventsList[this.currentDayIndex]
            }
        },
        methods: {
            ...mapActions([
                'getPromocodeAffectedEvents',
                'closeModal',
            ]),
            getEventsList: function () {
                this.isLoading = true
                this.getPromocodeAffectedEvents(this.getSelectedPromocode).then(response => {
                    this.isLoading = false
                    this.eventsList = response.data
                })
            },
            getDateToDisplay: function(input) {
                return input.dateDay.split(" ")[0]
            },
            getEventStartHour: function(event) {
                return moment(event.start).format('HH:mm')
            },
            getEventName: function (event) {
                if(event.nameAlias != "" && event.nameAlias!= null){
                    return event.nameAlias
                } else {
                    return event.product.name
                }
            },
            nextDay: function () {
                console.log('nextDay');
                if(this.currentDayIndex < (this.numberOfDays + 1)){
                    this.currentDayIndex++
                }
            },
            previousDay: function () {
                console.log('previousDay');
                if(this.currentDayIndex > 0){
                    this.currentDayIndex--
                }
            },
            pressOk: function() {
                this.closeModal();
            },
        },
        components: {
            Modal,
            Loader
        }
    }
</script>

<style lang="scss" scoped>
    .eventList{
        max-height: 500px;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// PromocodeAffectedEvents.vue?b561ed16